import { HasAccess } from "@permify/react-role";
import {
  Button,
  Radio,
  Col,
  Form,
  Modal,
  Row,
  Spin,
} from "antd";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

const ImportAnamnesisModal = ({
  importAnamnesisModal,
}) => {
  const { t } = useTranslation();
  const {
    modalVisible,
    closeModal,
    form,
    loading,
    patientFullName,
    availableAnamneses,
    selectedAnamnesis,
    onCheck,
    importAnamnesis,
  } = importAnamnesisModal;

  const customTableHeader = () => (
    <Row className="table-header">
      <Col
        lg={1}
        className="p-10"
      />
      <Col
        lg={4}
        className="p-10"
      >
        <h3>Batería o examen</h3>
      </Col>
      <Col
        lg={19}
        className="p-10"
      >
        <h3>Anamnesis</h3>
      </Col>
    </Row>
  );

  return (
    <Fragment>
      {modalVisible &&
        <Modal
          open={modalVisible.state}
          onCancel={closeModal}
          centered
          closable
          footer={false}
          width={'80vw'}
          style={{ maxHeight: '90vh' }}
          className="import-anamnesis-modal"
        >
          <Row justify="center" className="pt-20 pb-10 pl-lg-15 pr-lg-15">
            {
              loading ?
                <Spin className="cmt-spin" />
                :
                <Col lg={24} xs={24}>
                  <Form className="cmt-form" form={form} onFinish={importAnamnesis}>
                    <Row gutter={[0, 15]}>
                      <Col lg={24} xs={24}>
                        <Row justify='space-between'>
                          <Col>
                            <h2 className="mb-0 title">
                                {t('medicalConsultations.importAnamnesisModal.title')}
                            </h2>
                          </Col>
                          <Col>
                            <p className="mb-0">
                              {t('medicalConsultations.importAnamnesisModal.patientTitle')}:&nbsp;
                              <strong className="ml-5">
                                {patientFullName || ''}
                              </strong>
                            </p>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={24} xs={24}>
                        <Row justify='space-between'>
                            <p className="mb-0">
                                {t('medicalConsultations.importAnamnesisModal.description')}
                            </p>
                        </Row>
                      </Col>
                      <Col lg={24} xs={24}>
                      {availableAnamneses?.length > 0 ? (
                        <Form.Item name="description" className="mb-0">
                          {customTableHeader()}
                            <Col lg={24} xs={24} className="form-input-wrapper">
                            {
                                availableAnamneses?.map((service, index) =>
                                service.name &&
                                <Row
                                    className={`table-body ${(index % 2 === 1) && 'white'} mb-15`}
                                    key={service.service_id}
                                >
                                    <Col
                                    lg={1}
                                    xs={12}
                                    className="center-item-start p-10"
                                    >
                                    <Radio
                                        value={service}
                                        onChange={onCheck}
                                        checked={selectedAnamnesis?.service_id === service.service_id}
                                    />
                                    </Col>
                                    <Col
                                    lg={4}
                                    xs={12}
                                    className="p-10"
                                    >
                                    <p className="mb-0">{service.name}</p>
                                    </Col>
                                    <Col
                                    lg={19}
                                    xs={24}
                                    className="p-10"
                                    >
                                    <p className="mb-0" style={{ whiteSpace: 'pre-line' }}>{service.anamnesis}</p>
                                    </Col>
                                </Row>
                                )
                            }
                          </Col>
                        </Form.Item>
                      ) : 
                        <Row justify="center" className="mt-15">
                        <Col>
                            <p className="mb-0">{t('medicalConsultations.importAnamnesisModal.importAnamnesisDisclaimer')}</p>
                        </Col>
                        </Row>
                      }
                      </Col>
                      {availableAnamneses?.length > 0 &&
                        <Col lg={24} xs={24}>
                          <Row justify="end" className="mt-15">
                            <Col>
                              <HasAccess
                                roles={['super_usuario', 'doctor', 'direccion_medica', 'medical_auditor']}
                                permissions='import-anamnesis'
                              >
                                <Button
                                  htmlType="submit"
                                  className="cmt-button primary"
                                  type="primary"
                                  size="large"
                                >
                                  Agregar
                                </Button>
                              </HasAccess>
                            </Col>
                          </Row>
                        </Col>
                      }
                    </Row>
                  </Form>
                </Col>
            }
          </Row>
        </Modal>
      }
    </Fragment>
  );
};

export default ImportAnamnesisModal;
